angular.module('mtic.components.dashboards.teacher_general').directive('classLessonSummary', function ($log, $q, EventManager, StudentDataService) {
      return {
            templateUrl: 'template.html',
            scope: {
                  classId: '=',
                  userId: '='
            },
            link: function (scope) {
                  var eventManager = new EventManager('teacherDashboard/classLessonSummary', scope);
                  scope.studentWork = null;
                  scope.loading = true;
                  StudentDataService.getStudentWorkAsTeacher(scope.userId, scope.classId).then(function(work){
                        scope.studentWork = work;
                        scope.loading = false;
                  })

                  scope.goToClassTable = function(){
                        eventManager.broadcast('teacher:unselectStudent')
                  }
            }
      }
})
